module.exports = __webpack_public_path__ + "img/plugin-how-it-works-info_6.867ba6ec.svg";